/**
 * Default Swiper options with accessibility features
 */

const FOCUSABLE_ELEMENTS = 'a[href], button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])';

/**
 * Set aria-label for slide based on content
 */
function setSlideAriaLabel(slide, index, total) {
  const isProduct = !!slide.querySelector('.product-card-wrapper');
  const label = `${isProduct ? 'Product' : 'Slide'} ${index + 1} of ${total}`;
  slide.setAttribute('aria-label', label);
}

/**
 * Manage tabindex for focusable elements in slides
 */
function manageSlideFocus(slide, isVisible) {
  const focusableElements = slide.querySelectorAll(FOCUSABLE_ELEMENTS);
  focusableElements.forEach((el) => {
    if (isVisible) {
      el.removeAttribute('tabindex');
    } else {
      el.setAttribute('tabindex', '-1');
    }
  });
}

/**
 * Default Swiper configuration with accessibility features
 */
export const defaultOptions = {
  slidesPerView: 1,
  spaceBetween: 20,
  a11y: true,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
    type: 'bullets'
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  },
  speed: 300,
  autoplay: false,
  on: {
    init: function () {
      // Set tabindex to -1 for all focusable elements in inactive slides
      this.slides.forEach((slide, i) => {
        const isVisible = slide.classList.contains('swiper-slide-visible');
        if (!isVisible) {
          manageSlideFocus(slide, false);
        }
        
        // Set aria labels after a brief delay to ensure DOM is ready
        setTimeout(() => {
          this.slides.forEach((slide, i) => {
            setSlideAriaLabel(slide, i, this.slides.length);
          });
        }, 50);
      });
    },
    
    slideChange: function () {
      // Manage tabindex on slide change
      this.slides.forEach((slide, i) => {
        const isVisible = slide.classList.contains('swiper-slide-visible');
        manageSlideFocus(slide, isVisible);
        setSlideAriaLabel(slide, i, this.slides.length);
      });

      // Mobile flip logic handled by mobile-flip feature module
      // Will be injected by the feature if enabled
    },
    
    observerUpdate: function () {
      this.slides.forEach((slide, i) => {
        setSlideAriaLabel(slide, i, this.slides.length);
      });
    }
  }
};

export { FOCUSABLE_ELEMENTS, setSlideAriaLabel, manageSlideFocus };

